import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { CMSState } from '../../cms/blocks/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { HeaderBlock, HeaderInterface } from '../blocks/custom_blocks/widgets/headerBlock.mod'
import { Link, NavLink } from 'react-router-dom'
import { Page } from '../../cms/page/types.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl } from '../../../helpers'
import { Widget, mk_widget, AsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import React from 'react'
import { TextBlock } from '../blocks/custom_blocks/widgets/textBlock'
import { textBlockClasses, headerBlockClasses } from '../blocks/style.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { MapType } from '../../cms/state/types.gen'
import { createButtonData } from '../../../utils'

export const formOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  forms: AsyncState<Array<WordPress.PostTypeResponse>>,
  state:PublicSiteState
) => Widget<never> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  forms: AsyncState<Array<WordPress.PostTypeResponse>>,
  state:PublicSiteState
) =>
  mk_widget({
    run: _ => {
      const header = page.blocks.filter(b => b.kind == "vidda/header" && b).pop()
      return <>
        { header && header.kind == 'vidda/header' && 
          HeaderBlock({
            blockName: 'vidda/header',
            title: header.attrs.title,
            intro: header.attrs.intro,
            // TODO - Set correct header type
            header_type: 'header one'
          },
          { style: headerBlockClasses }
        )({} as CMSState<{}, {}, never>)(state).run(_ => {})}

        { forms.kind == 'loaded' && 
          <div className="list-overview">
            {forms.value.map(update => (
              TextBlock({
                title: update.title.rendered,
                text: update.excerpt.rendered ? update.excerpt.rendered : update.content.rendered,
                primary_button: createButtonData("Naar formulier",toRelativeUrl(update.link)),
                has_show_more: false
              }, {
                // style: textBlockClasses
              })({} as CMSState<{}, {}, never>).run(_ => {}) 
            ))}
          </div>
        }
      </>
    }
  })



export let countries_list = [
"Afghanistan",
"Albania",
"Algeria",
"American Samoa",
"Andorra",
"Angola",
"Antigua and Barbuda",
"Argentina",
"Armenia",
"Aruba",
"Australia",
"Austria",
"Azerbaijan",
"Bahamas",
"Bahrain",
"Bangladesh",
"Barbados",
"Belarus",
"Belgium",
"Belize",
"Benin",
"Bermuda",
"Bhutan",
"Bolivia",
"Bosnia and Herzegovina",
"Botswana",
"Brazil",
"British Virgin Islands",
"Brunei Darussalam",
"Bulgaria",
"Burkina Faso",
"Burundi",
"Cabo Verde",
"Cambodia",
"Cameroon",
"Canada",
"Cayman Islands",
"Central African Republic",
"Chad",
"Chile",
"China",
"Colombia",
"Comoros",
"Congo Brazzaville",
"Congo Kinshasa",
"Costa Rica",
"Côte D'Ivoire",
"Croatia",
"Cuba",
"Cyprus",
"Czech Republic",
"Denmark",
"Djibouti",
"Dominica",
"Dominican Republic",
"Ecuador",
"Egypt",
"El Salvador",
"Equatorial Guinea",
"Eritrea",
"Estonia",
"Eswatini",
"Ethiopia",
"Faroe Island",
"Fiji",
"Finland",
"France",
"French Guiana",
"French Polynesia",
"Gabon",
"Gambia ",
"Georgia",
"Germany",
"Ghana",
"Gilbraltar",
"Greece",
"Greenland",
"Grenada",
"Guam",
"Guandeloupe",
"Guatemala",
"Guinea",
"Guinea Bissau",
"Guyana",
"Haiti",
"Honduras",
"Hong Kong SAR",
"Hungary",
"Iceland",
"India",
"Indonesia",
"Iran ",
"Iraq",
"Ireland",
"Isle of Man",
"Israel",
"Italy",
"Jamaica",
"Japan",
"Jordan",
"Kazakhstan",
"Kenya",
"Kiribati",
"Kuwait",
"Kyrgyzstan",
"Laos",
"Latvia",
"Lebanon",
"Lesotho",
"Liberia",
"Libya",
"Liechtenstein",
"Lithuania",
"Luxembourg",
"Macau SAR",
"Macedonia",
"Madagascar",
"Malawi",
"Malaysia",
"Maldives",
"Mali",
"Malta",
"Marshall Islands",
"Martinique",
"Mauritania",
"Mauritius",
"Mayotte",
"Mexico",
"Micronesia ",
"Moldova",
"Monaco",
"Mongolia",
"Montenegro",
"Montserrat",
"Morocco",
"Mozambique",
"Myanmar",
"Namibia",
"Nauru",
"Nepal",
"Netherlands",
"New Caledonia",
"New Zealand",
"Nicaragua",
"Niger",
"Nigeria",
"Norway",
"Nothern Mariana Islands",
"Oman",
"Pakistan",
"Palau",
"Palestinian Territories",
"Panama",
"Papua New Guinea",
"Paraguay",
"Peru",
"Philippines",
"Poland",
"Portugal",
"Puerto Rico",
"Qatar",
"ReUnion",
"Romania",
"Russian",
"Rwanda",
"Saint Helena",
"Saint Kitts and Nevis",
"Saint Lucia",
"Saint Pierre and Miquelon",
"Saint Vincent and the Grenadines",
"Samoa",
"San Marino",
"Sao Tome and Principe",
"Saudi Arabia",
"Senegal",
"Serbia",
"Seychelles",
"Sierra Leone",
"Singapore",
"Slovakia",
"Slovenia",
"Solomon Islands",
"Somalia",
"South Africa",
"South Korea",
"South Sudan",
"Spain",
"Sri Lanka",
"Sudan",
"Suriname",
"Sweden",
"Switzerland",
"Syria",
"Taiwan",
"Tajikistan",
"Tanzania",
"Thailand",
"Timor-Leste",
"Togo",
"Tonga",
"Trinidad and Tobago",
"Tunisia",
"Turkey",
"Turkmenistan",
"Turks and Caicos Islands",
"Tuvalu",
"Uganda",
"Ukraine",
"United Arab Emirates",
"United Kingdom ",
"United States",
"Uruguay",
"Uzbekistan",
"Vanuatu",
"Venezuela",
"Vietnam",
"Yemen",
"Zambia",
"Zimbabwe"
]